import React, {useState} from "react";
import {useParams} from "react-router-dom";
import styles from "../login/login.module.css";
import {PrimaryButton, TextInput} from "../../../components/input/inputs";
import axiosInstance from "../../../AxiosInstance";
import {useTranslation} from "react-i18next";

export default function SetNewPassword() {
    const {t} = useTranslation();
    const {token } = useParams();
    const [form, setForm] = useState({token:token});
    const [showMessage, setShowMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const handleSubmit = () => {
        if(Object.keys(form).length < 1) return;
        axiosInstance.put('forgot/1/', form).then((response) => {
            setShowMessage(true);
            setShowErrorMessage(false);
            localStorage.clear();
            localStorage.setItem('access_token', response.data.access_token);
            window.location.replace('/');
        }).catch((err) => {
            console.log("err");
            setShowMessage(false);
            setShowErrorMessage(true);
        });
    }

    return (
        <div className={styles.container}>
            <div className={styles.background}>
                <img alt={'background'} src={'/login.png'} width={'100%'}/>
            </div>

            <div className={`${styles.loginContainer} px-4 pt-2`}>
                <div className={'pt-4 pb-2'}>
                    <div className={styles.title}>{t('auth.resetPassword.title')}</div>
                    <div className={`${styles.description} mt-2`}>{t('auth.resetPassword.description')}</div>
                </div>

                {showMessage &&
                    <div className={`${styles.message} px-3 py-2`}>
                        <div>{t('auth.resetPassword.success')}</div>
                    </div>
                }
                {showErrorMessage &&
                    <div className={`${styles.error} px-3 py-2`}>
                        <div>{t('auth.resetPassword.error')}</div>
                    </div>
                }

                {!showMessage &&
                    <div>
                        <div className={'mt-3'}>
                            <TextInput password={true} name={'password'} form={form} setForm={setForm} placeholder={'******'} hideName={true}/>
                        </div>

                        <div className={'mb-3'}>
                            <PrimaryButton name={t('auth.resetPassword.send')} onClick={handleSubmit}/>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}